import React, { useState, useEffect, useRef } from "react";
import BackgroundImage from "./BackgroundImage";
import { Placeholder, ImageWrapper } from "./StyledBgImage";
import { useObserver } from "Hooks/useObserver";

const LazyBackgroundImage = ({
	source,
	height,
	timeout = 200,
	children,
	paddingBottom,
	useFocalPoint,
	...imageProps
}) => {
	const domRef = useRef();
	const [isVisible, setVisible] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [placeholderSource, setPlaceholderSource] = useState("");
	const observe = useObserver(domRef);
	useEffect(() => {
		if (!isVisible && observe) {
			setVisible(true);
		}
	}, [observe]);

	useEffect(() => {
		if (isVisible) {
			setTimeout(() => setFadeIn(isVisible), timeout);
		}
	}, [isVisible]);

	useEffect(() => {
		let query = source.indexOf("?") > -1 ? "&width=10" : "?width=10";
		setPlaceholderSource(source + query);
	}, []);

	return (
		<ImageWrapper paddingBottom={paddingBottom} height={height} ref={domRef}>
			<Placeholder {...imageProps} bgImage={placeholderSource} fadeIn={true} />
			{isVisible && (
				<BackgroundImage
					{...imageProps}
					source={source}
					onLoad={fadeIn}
					useFocalPoint={useFocalPoint}
				>
					{children != undefined && children}
				</BackgroundImage>
			)}
		</ImageWrapper>
	);
};

export default LazyBackgroundImage;
